import type { Command, CommandContext } from "./Command";
import type { EntityId } from "../../world/Entity";
import type { InventoryCategory } from "../../inventory/Inventory";

export class TakeItemCommand implements Command {
  constructor(
    private readonly entityId: EntityId,
    private readonly category: InventoryCategory,
    private readonly stackable: boolean,
  ) {}

  execute(context: CommandContext): void {
    const entity = context.world.getEntity(this.entityId);
    if (!entity) throw new Error(`Cannot take unknown entity "${this.entityId}"`);

    context.world.removeEntityFromScene(this.entityId);
    const instanceId = crypto.randomUUID();
    context.world.addToInventory({
      instanceId,
      definitionId: entity.definitionId,
      quantity: 1,
      category: this.category,
      stackable: this.stackable,
      favorite: false,
      metadata: { kind: entity.kind, components: entity.components },
    });
    context.events.emit("item:taken", { entityId: this.entityId, instanceId });
  }
}
